import { render } from "./FattureScaduteOneYear.vue?vue&type=template&id=5447f808&scoped=true"
import script from "./FattureScaduteOneYear.vue?vue&type=script&lang=js"
export * from "./FattureScaduteOneYear.vue?vue&type=script&lang=js"

import "./FattureScaduteOneYear.vue?vue&type=style&index=0&id=5447f808&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5447f808"]])

export default __exports__